<template>
    <form class="content-form form-horizontal" @submit.prevent="submit()">
        <span style="color:#737373;"><i>Nota: El desarrollo actual admite obligatoriamente seis (6) vitrinas activas. Todos los campos con * son obligatorios.</i></span>
        <hr>
        <div class="form-group">
            <label class="col-sm-2 control-label subtitle" style="color:cornflowerblue"><em>Vitrina P1</em></label>
        </div>
        <div class="form-group" :class="{'has-error': errors['titleVitrina1']}">
            <label for="titleVitrina1" class="col-sm-2 control-label">Título*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="titleVitrina1" maxlength="120" v-model="data.titleVitrina1">
                <div class="help-block" v-for="e in errors['titleVitrina1']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['urlVitrina1']}">
            <label for="urlVitrina1" class="col-sm-2 control-label">URL*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="urlVitrina1" v-model="data.urlVitrina1">
                <div class="help-block" v-for="e in errors['urlVitrina1']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['targetVitrina1']}">
            <label for="targetVitrina1" class="col-sm-2 control-label">¿Abre en nueva pestaña?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.targetVitrina1" on-text="" off-text=""></el-switch>
            </div>
        </div>
        <!-- <div class="form-group" :class="{'has-error': errors['descriptionVitrina1']}">
            <label for="descriptionVitrina1" class="col-sm-2 control-label">Descripción*</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="descriptionVitrina1" cols="30" rows="3" maxlength="120" v-model="data.descriptionVitrina1"></textarea>
                <div class="help-block" v-for="e in errors['descriptionVitrina1']">{{e}}</div>
            </div>
        </div> -->
        <hr>
        <div class="form-group">
            <label class="col-sm-2 control-label subtitle" style="color:cornflowerblue"><em>Vitrina P1R</em></label>
        </div>
        <div class="form-group" :class="{'has-error': errors['titleVitrina2']}">
            <label for="titleVitrina2" class="col-sm-2 control-label">Título*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="titleVitrina2" maxlength="60" v-model="data.titleVitrina2">
                <div class="help-block" v-for="e in errors['titleVitrina2']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['SubtitleVitrina2_1']}">
            <label for="SubtitleVitrina2_1" class="col-sm-2 control-label">Subtítulo 1*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="SubtitleVitrina2_1" maxlength="100" v-model="data.SubtitleVitrina2_1">
                <div class="help-block" v-for="e in errors['SubtitleVitrina2_1']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['urlVitrina2_1']}">
            <label for="urlVitrina2_1" class="col-sm-2 control-label">URL 1*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="urlVitrina2_1" v-model="data.urlVitrina2_1">
                <div class="help-block" v-for="e in errors['urlVitrina2_1']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['SubtitleVitrina2_2']}">
            <label for="SubtitleVitrina2_2" class="col-sm-2 control-label">Subtítulo 2*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="SubtitleVitrina2_2" maxlength="100" v-model="data.SubtitleVitrina2_2">
                <div class="help-block" v-for="e in errors['SubtitleVitrina2_2']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['urlVitrina2_2']}">
            <label for="urlVitrina2_2" class="col-sm-2 control-label">URL 2*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="urlVitrina2_2" v-model="data.urlVitrina2_2">
                <div class="help-block" v-for="e in errors['urlVitrina2_2']">{{e}}</div>
            </div>
        </div>
        <hr>

        <div class="form-group">
            <label class="col-sm-2 control-label subtitle" style="color:cornflowerblue"><em>Vitrina P2</em></label>
        </div>
        <div class="form-group" :class="{'has-error': errors['titleVitrina3']}">
            <label for="titleVitrina3" class="col-sm-2 control-label">Título*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="titleVitrina3" maxlength="100" v-model="data.titleVitrina3">
                <div class="help-block" v-for="e in errors['titleVitrina3']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['urlVitrina3']}">
            <label for="urlVitrina3" class="col-sm-2 control-label">URL*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="urlVitrina3" v-model="data.urlVitrina3">
                <div class="help-block" v-for="e in errors['urlVitrina3']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['targetVitrina3']}">
            <label for="targetVitrina3" class="col-sm-2 control-label">¿Abre en nueva pestaña?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.targetVitrina3" on-text="" off-text=""></el-switch>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['descriptionVitrina3']}">
            <label for="descriptionVitrina3" class="col-sm-2 control-label">Descripción*</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="descriptionVitrina3" cols="30" rows="3" maxlength="120" v-model="data.descriptionVitrina3"></textarea>
                <div class="help-block" v-for="e in errors['descriptionVitrina3']">{{e}}</div>
            </div>
        </div>
        <hr>

        <!-- VITRINA P3 -->
        <div class="form-group">
            <label class="col-sm-2 control-label subtitle" style="color:cornflowerblue"><em>Vitrina P4</em></label>
        </div>
        <div class="form-group" :class="{'has-error': errors['titleVitrina4']}">
            <label for="titleVitrina4" class="col-sm-2 control-label">Título*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="titleVitrina4" maxlength="100" v-model="data.titleVitrina4">
                <div class="help-block" v-for="e in errors['titleVitrina4']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['urlVitrina4']}">
            <label for="urlVitrina4" class="col-sm-2 control-label">URL*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="urlVitrina4" v-model="data.urlVitrina4">
                <div class="help-block" v-for="e in errors['urlVitrina4']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['targetVitrina4']}">
            <label for="targetVitrina4" class="col-sm-2 control-label">¿Abre en nueva pestaña?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.targetVitrina4" on-text="" off-text=""></el-switch>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['descriptionVitrina4']}">
            <label for="descriptionVitrina4" class="col-sm-2 control-label">Descripción*</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="descriptionVitrina4" cols="30" rows="3" maxlength="120" v-model="data.descriptionVitrina4"></textarea>
                <div class="help-block" v-for="e in errors['descriptionVitrina4']">{{e}}</div>
            </div>
        </div>
        <hr>

        <!-- VITRINA P4 -->
        <div class="form-group">
            <label class="col-sm-2 control-label subtitle" style="color:cornflowerblue"><em>Vitrina P3</em></label>
        </div>
        <div class="form-group" :class="{'has-error': errors['titleVitrina5']}">
            <label for="titleVitrina5" class="col-sm-2 control-label">Título*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="titleVitrina5" maxlength="100" v-model="data.titleVitrina5">
                <div class="help-block" v-for="e in errors['titleVitrina5']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['urlVitrina5']}">
            <label for="urlVitrina5" class="col-sm-2 control-label">URL*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="urlVitrina5" v-model="data.urlVitrina5">
                <div class="help-block" v-for="e in errors['urlVitrina5']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['targetVitrina5']}">
            <label for="targetVitrina5" class="col-sm-2 control-label">¿Abre en nueva pestaña?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.targetVitrina5" on-text="" off-text=""></el-switch>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['descriptionVitrina5']}">
            <label for="descriptionVitrina5" class="col-sm-2 control-label">Descripción*</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="descriptionVitrina5" cols="30" rows="3" maxlength="120" v-model="data.descriptionVitrina5"></textarea>
                <div class="help-block" v-for="e in errors['descriptionVitrina5']">{{e}}</div>
            </div>
        </div>
        <hr>

        <!-- VITRINA P5 -->
        <div class="form-group">
            <label class="col-sm-2 control-label subtitle" style="color:cornflowerblue"><em>Vitrina P5</em></label>
        </div>
        <div class="form-group" :class="{'has-error': errors['titleVitrina6']}">
            <label for="titleVitrina6" class="col-sm-2 control-label">Título*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="titleVitrina6" maxlength="100" v-model="data.titleVitrina6">
                <div class="help-block" v-for="e in errors['titleVitrina6']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['urlVitrina6']}">
            <label for="urlVitrina6" class="col-sm-2 control-label">URL*</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="urlVitrina6" v-model="data.urlVitrina6">
                <div class="help-block" v-for="e in errors['urlVitrina6']">{{e}}</div>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['targetVitrina6']}">
            <label for="targetVitrina6" class="col-sm-2 control-label">¿Abre en nueva pestaña?</label>
            <div class="col-sm-10">
                <el-switch v-model="data.targetVitrina6" on-text="" off-text=""></el-switch>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors['descriptionVitrina6']}">
            <label for="descriptionVitrina6" class="col-sm-2 control-label">Descripción*</label>
            <div class="col-sm-10">
                <textarea class="form-control" id="descriptionVitrina6" cols="30" rows="3" maxlength="120" v-model="data.descriptionVitrina6"></textarea>
                <div class="help-block" v-for="e in errors['descriptionVitrina6']">{{e}}</div>
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    .el-select {
        display: block;
    }
</style>
<script>
    import ElSwitch from 'element-ui/lib/switch';
    import { Message } from "element-ui";

    export default {
        data: function () {
            return {
                data: _.cloneDeep(this.vitrinas),
                errors: {}
            }
        },
        props: ['vitrinas'],
        components: {
            ElSwitch,
        },
        methods: {
            submit: function () {
                var self = this;
                var errores = {};

                // Title's Errors

                if (!self.data.titleVitrina1 || self.data.titleVitrina1.length == 0) {
                    errores["titleVitrina1"] = ["Debe ingresar un título."];
                }
                if (!self.data.titleVitrina2 || self.data.titleVitrina2.length == 0) {
                    errores["titleVitrina2"] = ["Debe ingresar un título."];
                }
                if (!self.data.SubtitleVitrina2_1 || self.data.SubtitleVitrina2_1.length == 0) {
                    errores["SubtitleVitrina2_1"] = ["Debe ingresar un Subtítulo."];
                }
                if (!self.data.SubtitleVitrina2_2 || self.data.SubtitleVitrina2_2.length == 0) {
                    errores["SubtitleVitrina2_2"] = ["Debe ingresar un Subtítulo."];
                }
                if (!self.data.titleVitrina3 || self.data.titleVitrina3.length == 0) {
                    errores["titleVitrina3"] = ["Debe ingresar un título."];
                }
                if (!self.data.titleVitrina4 || self.data.titleVitrina4.length == 0) {
                    errores["titleVitrina4"] = ["Debe ingresar un título."];
                }
                if (!self.data.titleVitrina5 || self.data.titleVitrina5.length == 0) {
                    errores["titleVitrina5"] = ["Debe ingresar un título."];
                }
                if (!self.data.titleVitrina6 || self.data.titleVitrina6.length == 0) {
                    errores["titleVitrina6"] = ["Debe ingresar un título."];
                }

                // Urls's Errors Part 1

                if (!self.data.urlVitrina1 || self.data.urlVitrina1.length == 0) {
                    errores["urlVitrina1"] = ["Debe ingresar una URL."];
                }
                if (!self.data.urlVitrina2_1 || self.data.urlVitrina2_1.length == 0) {
                    errores["urlVitrina2_1"] = ["Debe ingresar una URL."];
                }
                if (!self.data.urlVitrina2_2 || self.data.urlVitrina2_2.length == 0) {
                    errores["urlVitrina2_2"] = ["Debe ingresar una URL."];
                }
                if (!self.data.urlVitrina3 || self.data.urlVitrina3.length == 0) {
                    errores["urlVitrina3"] = ["Debe ingresar una URL."];
                }
                if (!self.data.urlVitrina4 || self.data.urlVitrina4.length == 0) {
                    errores["urlVitrina4"] = ["Debe ingresar una URL."];
                }
                if (!self.data.urlVitrina5 || self.data.urlVitrina5.length == 0) {
                    errores["urlVitrina5"] = ["Debe ingresar una URL."];
                }
                if (!self.data.urlVitrina6 || self.data.urlVitrina6.length == 0) {
                    errores["urlVitrina6"] = ["Debe ingresar una URL."];
                }

                // Urls's Errors Part 2

                if (self.data.urlVitrina1.length > 0) {
                    if (self.data.urlVitrina1.substring(0, 5) != "https") {
                        errores["urlVitrina1"] = ["Debe ingresar una URL completa que utilice protocolo seguro 'https'."];
                    }
                }
                if (self.data.urlVitrina2_1.length > 0) {
                    if (self.data.urlVitrina2_1.substring(0, 5) != "https") {
                        errores["urlVitrina2_1"] = ["Debe ingresar una URL completa que utilice protocolo seguro 'https'."];
                    }
                }
                if (self.data.urlVitrina2_2.length > 0) {
                    if (self.data.urlVitrina2_2.substring(0, 5) != "https") {
                        errores["urlVitrina2_2"] = ["Debe ingresar una URL completa que utilice protocolo seguro 'https'."];
                    }
                }

                if (self.data.urlVitrina3.length > 0) {
                    if (self.data.urlVitrina3.substring(0, 5) != "https") {
                        errores["urlVitrina3"] = ["Debe ingresar una URL completa que utilice protocolo seguro 'https'."];
                    }
                }

                if (self.data.urlVitrina4.length > 0) {
                    if (self.data.urlVitrina4.substring(0, 5) != "https") {
                        errores["urlVitrina4"] = ["Debe ingresar una URL completa que utilice protocolo seguro 'https'."];
                    }
                }

                if (self.data.urlVitrina5.length > 0) {
                    if (self.data.urlVitrina5.substring(0, 5) != "https") {
                        errores["urlVitrina5"] = ["Debe ingresar una URL completa que utilice protocolo seguro 'https'."];
                    }
                }

                if (self.data.urlVitrina6.length > 0) {
                    if (self.data.urlVitrina6.substring(0, 5) != "https") {
                        errores["urlVitrina6"] = ["Debe ingresar una URL completa que utilice protocolo seguro 'https'."];
                    }
                }

                // Urls's Errors Part 3

                if (/\s/g.test(self.data.urlVitrina1)) {
                    errores["urlVitrina1"] = ["El campo Url no puede contener espacios."];
                }
                if (/\s/g.test(self.data.urlVitrina2_1)) {
                    errores["urlVitrina2_1"] = ["El campo Url no puede contener espacios."];
                }
                if (/\s/g.test(self.data.urlVitrina2_2)) {
                    errores["urlVitrina2_2"] = ["El campo Url no puede contener espacios."];
                }
                if (/\s/g.test(self.data.urlVitrina3)) {
                    errores["urlVitrina3"] = ["El campo Url no puede contener espacios."];
                }
                if (/\s/g.test(self.data.urlVitrina4)) {
                    errores["urlVitrina4"] = ["El campo Url no puede contener espacios."];
                }
                if (/\s/g.test(self.data.urlVitrina5)) {
                    errores["urlVitrina5"] = ["El campo Url no puede contener espacios."];
                }
                if (/\s/g.test(self.data.urlVitrina6)) {
                    errores["urlVitrina6"] = ["El campo Url no puede contener espacios."];
                }

                // Description's Erros

                // if (!self.data.descriptionVitrina1 || self.data.descriptionVitrina1.length == 0) {
                //     errores["descriptionVitrina1"] = ["Debe ingresar una descripción."];
                // }
                // if (!self.data.descriptionVitrina2 || self.data.descriptionVitrina2.length == 0) {
                //     errores["descriptionVitrina2"] = ["Debe ingresar una descripción."];
                // }
                if (!self.data.descriptionVitrina3 || self.data.descriptionVitrina3.length == 0) {
                    errores["descriptionVitrina3"] = ["Debe ingresar una descripción."];
                }
                if (!self.data.descriptionVitrina4 || self.data.descriptionVitrina4.length == 0) {
                    errores["descriptionVitrina4"] = ["Debe ingresar una descripción."];
                }
                if (!self.data.descriptionVitrina5 || self.data.descriptionVitrina5.length == 0) {
                    errores["descriptionVitrina5"] = ["Debe ingresar una descripción."];
                }
                if (!self.data.descriptionVitrina6 || self.data.descriptionVitrina6.length == 0) {
                    errores["descriptionVitrina6"] = ["Debe ingresar una descripción."];
                }

                if (_.size(errores) > 0 || self.disabled == true) {

                    self.errors = errores;
                    self.$message.error(
                    "Revise los errores en el formulario para continuar."
                    );
                    return false;
                }else{
                    axios({
                        url: 'backend/vitrina-principal',
                        method: 'POST',
                        data: self.data,
                    }).then((response) => {
                        window.location.replace(response.data.redirect);
                    }).catch((error) => {
                        self.errors = error.response.data.errors;
                    });
                }
            }
        }
    }
</script>